/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { PoolMathTester, PoolMathTesterInterface } from '../PoolMathTester'

const _abi = [
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_m',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_deltaMargin',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_l',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_deltaL',
        type: 'int256'
      }
    ],
    name: 'testCalculateMarginDivLiquidity',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
]

const _bytecode =
  '0x608060405234801561001057600080fd5b5061040d806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063b2e0328e14610030575b600080fd5b61005f6004803603608081101561004657600080fd5b5080359060208101359060408101359060600135610071565b60408051918252519081900360200190f35b600061007f85858585610088565b95945050505050565b60008083136100d3576040805162461bcd60e51b81526020600482015260126024820152716c206d75737420626520706f73697469766560701b604482015290519081900360640190fd5b60006100e9866100e3818061019f565b9061019f565b905061011161010a600261010460036100e38a818d8061019f565b90610251565b8290610309565b905061012461010a866100e3898261019f565b905061013c61010a6004610104886100e3818061019f565b9050610152846101048181856305f5e10061019f565b90506101956101618585610309565b61010461016e8787610309565b6101046305f5e1006100e361018e6101878b6002610251565b8c90610309565b889061019f565b9695505050505050565b6000826101ae5750600061024b565b826000191480156101c25750600160ff1b82145b156101fe5760405162461bcd60e51b81526004018080602001828103825260278152602001806103b16027913960400191505060405180910390fd5b8282028284828161020b57fe5b05146102485760405162461bcd60e51b81526004018080602001828103825260278152602001806103b16027913960400191505060405180910390fd5b90505b92915050565b6000816102a5576040805162461bcd60e51b815260206004820181905260248201527f5369676e6564536166654d6174683a206469766973696f6e206279207a65726f604482015290519081900360640190fd5b816000191480156102b95750600160ff1b83145b156102f55760405162461bcd60e51b81526004018080602001828103825260218152602001806103906021913960400191505060405180910390fd5b600082848161030057fe5b05949350505050565b600082820181831280159061031e5750838112155b80610333575060008312801561033357508381125b6102485760405162461bcd60e51b815260040180806020018281038252602181526020018061036f6021913960400191505060405180910390fdfe5369676e6564536166654d6174683a206164646974696f6e206f766572666c6f775369676e6564536166654d6174683a206469766973696f6e206f766572666c6f775369676e6564536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f77a26469706673582212201c5ba4fcd7c1b0020e5c0996f256d116ff6e22670302b694687d47b364c4b55964736f6c63430007060033'

export class PoolMathTester__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PoolMathTester> {
    return super.deploy(overrides || {}) as Promise<PoolMathTester>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PoolMathTester {
    return super.attach(address) as PoolMathTester
  }
  connect(signer: Signer): PoolMathTester__factory {
    return super.connect(signer) as PoolMathTester__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PoolMathTesterInterface {
    return new utils.Interface(_abi) as PoolMathTesterInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PoolMathTester {
    return new Contract(address, _abi, signerOrProvider) as PoolMathTester
  }
}
